import type {LinkField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import {PrismicNextLink} from '@prismicio/next/pages'
import {useLinkResolver} from 'prismicio'
import type {ReactNode} from 'react'
import {memo} from 'react'
import type {TrackingProps} from 'src/common/helpers'
import {EVENTS, track} from 'src/common/helpers'

type LinkWrapperProps = {
  link: LinkField
  children: ReactNode
  className?: string
} & Omit<TrackingProps, 'event'> & {
    onMouseEnter?: () => void
    onMouseLeave?: () => void
  }

export const LinkWrapper = memo(
  ({link, children, className, mktgId, location, pageName, dataType, onMouseEnter, onMouseLeave}: LinkWrapperProps) => {
    const {linkResolver} = useLinkResolver()

    if (!isFilled.link(link)) {
      return children
    }

    return (
      <PrismicNextLink
        href={linkResolver(link)}
        {...(link.link_type === 'Document' && link.lang ? {locale: link.lang} : {})}
        className={className ?? ''}
        onClick={() =>
          track({
            event: EVENTS.CLICK,
            mktgId,
            location,
            pageName,
            dataType,
          })
        }
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </PrismicNextLink>
    )
  },
)
